
import React from 'react';
import { Card } from "@/components/ui/card";
import { Match } from '../types/head-to-head';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface TeamFormProps {
  teamName: string;
  matches: Match[];
  getTeamResults: (team: string) => string[];
  getResultColor: (result: string) => string;
  onMatchSelect: (index: number | null) => void;
  selectedMatchIndex: number | null;
}

export const TeamForm: React.FC<TeamFormProps> = ({
  teamName,
  matches,
  getTeamResults,
  getResultColor,
  onMatchSelect,
  selectedMatchIndex
}) => {
  const formatMatchResult = (match: Match, result: string) => {
    const isHome = match.HomeTeam === teamName;
    const homeTeam = match.HomeTeam;
    const awayTeam = match.AwayTeam;
    const score = `${match.FTHG}-${match.FTAG}`;
    return `${homeTeam} ${score} ${awayTeam}`;
  };

  const results = getTeamResults(teamName);
  
  return (
    <Card className="p-4">
      <h3 className="text-lg font-semibold mb-3">{teamName} Form</h3>
      <div className="flex gap-2 flex-wrap">
        <TooltipProvider>
          {results.map((result, index) => (
            <Tooltip key={index}>
              <TooltipTrigger asChild>
                <button
                  onClick={() => onMatchSelect(selectedMatchIndex === index ? null : index)}
                  className={`w-10 h-10 flex items-center justify-center font-bold rounded transition-colors ${getResultColor(result)}`}
                >
                  {result}
                </button>
              </TooltipTrigger>
              <TooltipContent>
                <p className="text-sm">
                  {formatMatchResult(matches[index], result)}
                </p>
                <p className="text-xs text-gray-400">
                  {matches[index].Date}
                </p>
              </TooltipContent>
            </Tooltip>
          ))}
        </TooltipProvider>
      </div>
    </Card>
  );
};
